<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        ref="table"
        :loading="loading"
        highlight-row
        :columns="evaluationColumns"
        :data="evaluationData"
        @on-row-click="rowClick"
        width="100%"
        stripe
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">评估信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        inline
        label-position="left"
        :disabled="evaluationDisable"
        v-if="showSelfData.EvaluationRecord == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'begindate' || val == 'enddate' || val == 'reviewdate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="val == 'howScore' || val == 'whatScore' || val == 'wholeScore' || val == 'potentialScore' "
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in score"
              :value="item.code"
              :key="item.code"
              :label="item.ch_value"
            ></Option>
          </Select>
          <Input
            v-else-if="val == 'note'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <!-- <Button type="primary" @click="saveData()" :disabled="evaluationDisable"
        >保存</Button
      > -->
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      plan: "",
      formItem: {},
      id: null,
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      evaluationType: [],
      chNameMap: {},
      enNameMap: {},
      evaluationData: [],
      serialnumber: "0001",
      evaluationDisable: false,
      showSelfData: {},
      userId: "",
      score:[],
      sortfMap: {},
      disableSelfData: {}
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    evaluationColumns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.year
              : this.enNameMap.year,
          key: "year",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.whatScore : this.enNameMap.whatScore,
          key: "whatScore",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "span",
              this.score
                .filter(item => item.code == params.row.whatScore)
                .map(res => res.ch_value)
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.howScore : this.enNameMap.howScore,
          key: "howScore",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "span",
              this.score
                .filter(item => item.code == params.row.howScore)
                .map(res => res.ch_value)
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.wholeScore
              : this.enNameMap.wholeScore,
          key: "wholeScore",
          align: "center",
          minWidth: 260,
          render: (h, params) => {
            return h(
              "span",
              this.score
                .filter(item => item.code == params.row.wholeScore)
                .map(res => res.ch_value)
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.potentialScore
              : this.enNameMap.potentialScore,
          key: "potentialScore",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "span",
              this.score
                .filter(item => item.code == params.row.potentialScore)
                .map(res => res.ch_value)
            );
          }
        },
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    initgetData(item) {
      this.loading = true;
      let Obj = {
        serialnumber: this.plan ? this.plan : this.userId,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        sheetId: this.id,
        bePersonal: this.plan ? "0" : "1"
      };
      axios
        .post("/userEvaluation/researchUserEvaluationInfo", Obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.evaluationData = res.data;
            this.total = Number(res.pageInfo.total);
            this.evaluationType = res.optionData.REVIEWTYPE;
            this.score = res.optionData.Score;
            this.disableSelfData = res.disableSelfData;
            // if (res.disableSelfData.EvaluationRecord == "0") {
            //   this.evaluationDisable = true;
            // }
            if(this.plan){
              if(res.disableSelfData.EvaluationRecord == "1"){
                this.evaluationDisable = true;
              }
            }else{
              if(res.disableSelfData.EvaluationRecord == "0"){
                this.evaluationDisable = true;
              }
            }
            this.showSelfData = res.showSelfData;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[13];
          }
        });
    },
    rowClick(row, index) {
      this.formItem = row;
    },
    // saveData() {
    //   this.$Modal.confirm({
    //     title: this.$notice("sureSave"),
    //     content: "",
    //     onOk: () => {
    //       axios
    //         .post("/userEvaluation/rollBackUserEvaluationInfo", this.formItem)
    //         .then(res => {
    //           this.initgetData();
    //         });
    //     },
    //     onCancel: () => {}
    //   });
    // },
    returnPage() {
      this.$router.back();
    },
    getData(item, plan) {
      (this.plan = plan ? plan : ""), (this.id = item);
      this.initgetData();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/EvaluationRecord.vue